import axios from "infra/http";
import { useMutation } from "react-query";
import { showError, showSuccess } from "infra/helpers/alerta";
import error from "core/resources/firebase/error";
import { queryClient } from "infra/packages/react-query";

function useAprovarSolicitacao() {
  return useMutation(
    (id: string) => {
      return axios.post(`/v1/solicitacao-cadastro/${id}/aprovar`, { id });
    },
    {
      onError(err: any) {
        showError(error[(err as any).code]);
      },
      onSuccess(_, id) {
        showSuccess("Solicitação aprovada com sucesso!");

        queryClient.setQueryData(["/solicitacao-cadastro", id], (data: any) => {
          return {
            ...data,
            status: "aprovado",
          };
        });
      },
    }
  );
}

export default useAprovarSolicitacao;
